import {
  breakpointSizes,
  getBreakpointDown,
  getBreakpointUp,
  styleConstants,
} from '@paywithextend/components'
import React from 'react'
import { useDispatch } from 'react-redux'
import Occlusion from 'src/components/Occlusion/Occlusion'
import { closeModal } from 'src/navigation/Lnk'
import { FlyoutFadeIn, RightFlyoutSlideIn } from 'src/style/keyframeUtils'
import { css } from 'styled-components'

export enum RightFlyoutBodyWidths {
  Action = 'action',
  Transaction = 'transaction',
}

interface RightFlyoutProps {
  className?: string
  width: RightFlyoutBodyWidths | number
  onClose?: () => void
  onScroll?: (e: React.UIEvent<HTMLElement>) => void
  childRef?: (node: HTMLDivElement) => void
  parentRef?: (node: HTMLDivElement) => void
  fullHeight?: boolean
  suppressCloseModalAction?: boolean
  occlusionOpacity?: number
}

const RightFlyout: React.FC<React.PropsWithChildren<RightFlyoutProps>> = (
  props,
): React.ReactElement => {
  const dispatch = useDispatch()

  return (
    <div
      className={props.className}
      css={css`
        z-index: 8;
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        overflow: auto;
      `}
    >
      <Occlusion
        css={css`
          z-index: 0;
          ${getBreakpointDown(breakpointSizes.XSM)(css`
            display: none;
          `)}
        `}
        isOpen
        onClick={(): void => {
          if (!props.suppressCloseModalAction) {
            dispatch(closeModal())
          }
          if (props.onClose) {
            props.onClose()
          }
        }}
        fadeIn
        opacity={props.occlusionOpacity}
      />
      <div
        id={'flyoutContent'}
        data-testid="flyout"
        css={css`
          z-index: 1;
          position: absolute;
          background-color: ${styleConstants.colors.gray_light};
          box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
          right: 0px;

          ${getBreakpointUp(breakpointSizes.SM)(css`
            ${props.width === RightFlyoutBodyWidths.Action &&
            css`
              width: 700px;
              ${RightFlyoutSlideIn(700)}
            `}

            ${props.width === RightFlyoutBodyWidths.Transaction &&
            css`
              width: 580px;
              ${RightFlyoutSlideIn(580)}
            `}

            ${typeof props.width === 'number' &&
            css`
              width: ${props.width}px;
              ${RightFlyoutSlideIn(props.width)}
            `}
          `)}

          ${getBreakpointDown(breakpointSizes.XSM)(css`
            width: 100vw;
            ${FlyoutFadeIn()}
            position: relative;
            z-index: 1;
            display: flex;
            align-self: stretch;
          `)}
        `}
      >
        <div
          id={'childContainer'}
          css={css`
            display: flex;
            flex-direction: column;
            width: 100%;
            overflow-y: auto;
            overflow-x: visible;
            height: 100vh;
          `}
          ref={props.childRef}
        >
          {props.children}
        </div>
      </div>
    </div>
  )
}

export default RightFlyout
